import { Component } from '@angular/core';
import { finalize } from 'rxjs';

import { MagicTokenService } from '@core/services/magic-token.service';

@Component({
  selector: 'app-help-msg-button',
  templateUrl: './help-msg-button.component.html',
  styleUrls: ['./help-msg-button.component.scss'],
})
export class HelpMsgButtonComponent {
  protected loading = false;

  constructor(private magicTokenService: MagicTokenService) {}

  openChatWidget(): void {
    if (this.loading) return;
    this.loading = true;

    (window as any).ChatWidget?.destroy();

    this.magicTokenService
      .requestMagicToken()
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((token) => {
        (window as any).ChatWidget?.createRoom('general', {
          magicToken: token.requestMagicToken,
        });
      });
  }
}
